import type ApplicationModel from 'components/framework/ApplicationModel';
import RecordAction from '../RecordAction';
import Iteration from 'components/framework/models/Iteration';
import terminology from 'javascripts/terminology';
import type { Feature, Requirement } from 'components/framework/models';

type RecordType = Feature | Requirement;
export class RemoveFromIteration extends RecordAction<RecordType> {
  recordTypes = ['Feature', 'Requirement'];

  get title() {
    return `Remove from ${terminology('iteration')}`;
  }

  showForRecord(record: ApplicationModel): record is RecordType {
    return !!(super.showForRecord(record) && record.iteration?.persisted);
  }

  async runForRecords(records: RecordType[]) {
    const recordsWithSprint = records.filter(
      record => record.iteration?.persisted
    );

    await Promise.all(
      recordsWithSprint.map(record =>
        record.update(
          { iteration: Iteration.blank() },
          { args: { __reactivelyUpdate: true } }
        )
      )
    );
  }
}
